import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { Menu } from '../Menu';

export const Container = styled(Box)({
  display        : 'flex',
  justifyContent : 'space-between',
  alignItems     : 'center',
  height         : '5.5rem',
  borderBottom   : '2px solid #E9E9E9',
  padding        : '0 2rem',
});

export const ContactDetails = styled(Box)(({ theme }) => ({
  color     : theme.palette.primary.gray6,
  '& label' : {
    fontSize      : '12px',
    textTransform : 'uppercase',
    lineHeight    : '1.66rem',
    fontFamily    : 'Montserrat',
  },
  '& .MuiTypography-root' : {
    fontFamily : 'Montserrat',
    fontWeight : '900',
  },
}));

export const Donate = styled(Box)(({ theme }) => ({
  display         : 'flex',
  height          : '100%',
  alignItems      : 'center',
  cursor          : 'pointer',
  fontFamily      : 'Montserrat',
  fontWeight      : '900',
  backgroundColor : theme.palette.primary.lightBlue1,
  color           : theme.palette.primary.white,
  padding         : '0 1rem',
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  color      : theme.palette.primary.blue1,
  fontFamily : 'Montserrat',
  fontWeight : '900',

  li : {
    fontFamily : 'Montserrat',
  },
}));
